import React, { useEffect, useState } from 'react'
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import { handleAllError } from '../CustomFunctions';
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import { formattedDateLong } from '../Date';
import { AttendancePolicyTable, DepartmentTable, DesignationTable, SalaryStructureFormatTable, SalaryStructureHeadingTable, Subcompany, WeeklyOffPolicyTable, Worksite } from '../workforcemanagement/Organizationtables';
import { SeprationFormatsTable } from '../SeprationManagement/SeprationTables';
import usePermission from '../../config/permissions';
import { LetterTemplatesTable } from '../DynamicBuilders/LetterBuilderManagement/LetterTemplateTables';
import AppraisalSetupDisplay from './AppraisalSetup/AppraisalSetupDisplay';



const PortalSetup = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    const [toggleState, setToggleState] = useState(2);
    useEffect(() => {
        setToggleState((PERMISSION_AUTHORITY && 1) || 2)
    }, [PERMISSION_AUTHORITY])

    return (
        <>
            <div>
                <div className="bloc-tabss  wfm-margin">

                    {PERMISSION_AUTHORITY && <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Sub Company
                    </button>}
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Department
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Designation
                    </button>
                    <button
                        className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(4)}
                    >
                        Worksite
                    </button>
                    <button
                        className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(5)}
                    >
                        Attendance Policies
                    </button>
                    <button
                        className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(6)}
                    >
                        Weeklyoff Policies
                    </button>

                    <button
                        className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(8)}
                    >
                        Salary Structure Formats
                    </button>
                    <button
                        className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(9)}
                    >
                        Separation Formats
                    </button>
                    <button
                        className={toggleState === 10 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(10)}
                    >
                        Letter Templates
                    </button>
                    {/* <button
                        className={toggleState === 11 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(11)}
                    >
                        Slip Builder
                    </button> */}
                    <button
                        className={toggleState === 12 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(12)}
                    >
                        Appraisal Setup
                    </button>
                </div>

                <div className="content-tabs">
                    {toggleState === 1 ? <Subcompany /> : null}
                    {toggleState === 2 ? <DepartmentTable /> : null}
                    {toggleState === 3 ? <DesignationTable /> : null}
                    {toggleState === 4 ? <Worksite /> : null}
                    {toggleState === 5 ? <AttendancePolicyTable /> : null}
                    {toggleState === 6 ? <WeeklyOffPolicyTable /> : null}
                    {/* {toggleState === 7 ? <SalaryStructureHeadingTable /> : null} */}
                    {toggleState === 8 ? <SalaryStructureFormatTable /> : null}
                    {toggleState === 9 ? <SeprationFormatsTable /> : null}
                    {toggleState === 10 ? <LetterTemplatesTable /> : null}
                    {/* {toggleState === 11 ? <></> : null} */}
                    {toggleState === 12 ? <AppraisalSetupDisplay /> : null}
                </div>
            </div>

        </>
    )
}

export default PortalSetup
